<template>
    <div id="bene-bank-transfer-container">
        <f7-list form class="form-group" v-if="showFormSet.bankTransfer">
            <f7-list-input
                v-if       ="showFormInput.bankTransfer.ifscCode"
                :label       ="$t('beneficiary-ifsc-code')"
                :placeholder ="$t('beneficiary-ifsc-code')"
                :value       ="ifscCode"

                disabled
                outline
                floating-label
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'ifscCode',
                'ifscBankBranch',
                'isbKashTx',
                'showPreloaderState',
                'forceRerenderKey',
                'isCreateBeneficiary',
            ])
        },
        components: {
        },
        methods: {
            ...mapActions('beneficiary', [
                'setShowPreloaderState'
            ]),
        }
    }
</script>